// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rb-alert[data-v-43be9a49] {\n  background-color: #feeeb7;\n  border: 1px solid #fdac41;\n  border-top: 0px;\n  border-radius: 0px 0px 5px 5px !important;\n}\n.rb-alert .alert-text[data-v-43be9a49],\n.rb-alert .fa-bell-exclamation[data-v-43be9a49] {\n  color: #af6708;\n}\n.text-dark-yellow[data-v-43be9a49] {\n  color: #af6717;\n}", ""]);
// Exports
module.exports = exports;
